import React, { useState } from 'react';
import {
  Container, Paper, Typography, TextField, Button,
  Box, Alert, Stack,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { createTrip } from '../services/api';

export default function AddTrip() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', description: '', startDate: '', endDate: '' });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return setError('Trip name is required.');
    setSaving(true);
    setError('');
    try {
      const { data } = await createTrip(form);
      navigate(`/trips/${data.tripId}`);
    } catch {
      setError('Failed to create trip. Please try again.');
      setSaving(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4, mb: 6 }}>
      <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/')} sx={{ mb: 2 }}>
        Back
      </Button>
      <Paper sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>Create New Trip</Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Box component="form" onSubmit={handleSubmit}>
          <Stack spacing={2.5}>
            <TextField
              label="Trip Name" required fullWidth
              value={form.name} onChange={set('name')}
              placeholder="e.g. Summer Vacation 2025"
            />
            <TextField
              label="Description" fullWidth multiline rows={3}
              value={form.description} onChange={set('description')}
              placeholder="What is this trip about?"
            />
            <Stack direction="row" spacing={2}>
              <TextField
                label="Start Date" type="date" fullWidth
                value={form.startDate} onChange={set('startDate')}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                label="End Date" type="date" fullWidth
                value={form.endDate} onChange={set('endDate')}
                InputLabelProps={{ shrink: true }}
              />
            </Stack>
            <Button
              type="submit" variant="contained" size="large"
              disabled={saving || !form.name.trim()}
            >
              {saving ? 'Creating...' : 'Create Trip'}
            </Button>
          </Stack>
        </Box>
      </Paper>
    </Container>
  );
}
